// export const OSS_URL = 'https://' + process.env.REACT_APP_OSS_BUCKET + '.com'

import { GlobalStorage } from '../storage'

export const PUBLIC_DATA_URL = process.env.REACT_APP_PUBLIC_DATA

export const BRAND_UNIT_CATEGORAY_TEMPLATE = `${PUBLIC_DATA_URL}/%E7%B1%BB%E7%9B%AE_%E5%8D%95%E4%BD%8D_%E5%93%81%E7%89%8C%E5%8F%82%E8%80%83%E6%95%B0%E6%8D%AE.xlsx`
export const TEMPLATE_BASE_URL = GlobalStorage.getStorageSync('BASEURL')
// export const OSS_URL = 'https://' + process.env.REACT_APP_OSS_BUCKET + '.com'

import { GlobalStorage } from '../storage'

export const PUBLIC_DATA_URL = process.env.REACT_APP_PUBLIC_DATA

export const BRAND_UNIT_CATEGORAY_TEMPLATE = `${PUBLIC_DATA_URL}/%E7%B1%BB%E7%9B%AE_%E5%8D%95%E4%BD%8D_%E5%93%81%E7%89%8C%E5%8F%82%E8%80%83%E6%95%B0%E6%8D%AE.xlsx`
export const TEMPLATE_BASE_URL = GlobalStorage.getStorageSync('BASEURL')
